export default __webpack_public_path__ + "static/media/crossout3.3025530a.mp3";